import { getMarketsFromMarketGroup } from './getMarketsFromMarketGroup';
export const matchSelections = (selectionsIds, selectedSelections, marketGroups) => {
    if (marketGroups) {
        marketGroups.forEach((marketGroup) => {
            const { players, periods, teams } = getMarketsFromMarketGroup(marketGroup);
            players.forEach((player) => {
                periods.forEach((period) => {
                    teams.forEach((team) => {
                        let selections = [];
                        if (player && team && period && marketGroup.markets[team][period][player]) {
                            ({ selections } = marketGroup.markets[team][period][player]);
                        }
                        else if (team && period && marketGroup.markets[team][period]) {
                            ({ selections } = marketGroup.markets[team][period]);
                        }
                        else if (team && !period) {
                            ({ selections } = marketGroup.markets[team]);
                        }
                        else if (!team && period) {
                            ({ selections } = marketGroup.markets[period]);
                        }
                        selections === null || selections === void 0 ? void 0 : selections.forEach((selection) => {
                            if (selectionsIds.has(selection.id)) {
                                selectedSelections.push(Object.assign({ category: marketGroup.category, categoryName: marketGroup.categoryName, team,
                                    period,
                                    player }, selection));
                                selectionsIds.delete(selection.id);
                            }
                        });
                    });
                });
            });
        });
    }
    return [selectedSelections, selectionsIds];
};
